export const FormLeadScoreFieldName = 'score';
export const FormConsentFieldName = 'consent';
